import { useEffect } from 'react';

export const useCloseModalOnFlag = ({ shouldClose, setShouldClose, setModalVisible }) => {
  useEffect(() => {
    if (shouldClose) {
      setModalVisible(false);
      setShouldClose(false);
    }
  }, [shouldClose]);
};
